import { useV2GetAccountQuery } from "@generated";
import { Account } from "../types";

const useGetAccount = () => {
  // v2 scopes the account to the bearer token, so there is no slug to pass.
  const { data, error, isLoading } = useV2GetAccountQuery({});

  let account: Account | null = null;
  let customError: string | null = null;

  if (data?.data && data.data.attributes?.["account-id"]) {
    try {
      account = {
        // `account-id` is still a number on the wire, but v2 resource
        // identifiers are strings, so normalize here - every consumer feeds
        // this straight into a JSON:API relationship.
        id: String(data.data.attributes["account-id"]),
        type: "accounts",
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return { account, error: error || customError, isLoading };
};

export default useGetAccount;
